import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterOutlet } from '@angular/router';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { BreakpointObserver } from '@angular/cdk/layout';
import { Topbar } from '@core/layout/topbar/topbar.component';
import { Sidebar } from '../sidebar/sidebar';
import {NgxLoadingBar} from '@ngx-loading-bar/core';
import Keycloak from 'keycloak-js';

@Component({
  selector: 'app-shell',
  imports: [
    RouterOutlet,
    MatToolbarModule,
    MatSidenavModule,
    MatIconModule,
    MatButtonModule,
    Topbar,
    Sidebar,
    NgxLoadingBar,
  ],
  templateUrl: './shell.html',
  styleUrl: './shell.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Shell {
  private breakpointObserver = inject(BreakpointObserver);
  private keycloak = inject(Keycloak);
  isMobile = signal(false);

  constructor() {
    this.breakpointObserver.observe(['(max-width: 768px)'])
      .pipe(takeUntilDestroyed())
      .subscribe(result => {
        this.isMobile.set(result.matches);
      });

    // Force-refresh the token on every app load so route guards always see current roles.
    this.keycloak.updateToken(-1).catch(() => {});
  }
}
